export default __webpack_public_path__ + "static/media/4.52317108.jpg";